import React from "react";
import NavBar from "../navbar";
import { Helmet } from "react-helmet";
import Footer from "../footer";
import { useTranslation } from "react-i18next";

const AppTemplate = ({
  pageTitle,
  parentTitle,
  navbar,
  footer,
  children,
  footerBackgroundColor,
}) => {
  const { t } = useTranslation();
  const appName = "Circassian Tribal Council - مجلس قبائل الشركس";
  return (
    <div>
      {pageTitle && (
        <Helmet>
          <title>
            {parentTitle
              ? t(parentTitle) + " "
              : t(pageTitle) + " | " + t(appName)}
          </title>
        </Helmet>
      )}
      {navbar && (
        <div className="navbar-content">
          <NavBar />
        </div>
      )}
      {children}
      {footer && <Footer backgroundColor={footerBackgroundColor} />}
    </div>
  );
};

export default AppTemplate;
